"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var hooks_1 = require("containers/InviteUserModal/hooks");
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var validators_1 = require("utils/form/validators");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var WizardParts_1 = require("./WizardParts");
var AccInviteMembers = function () {
    var _a;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'invitations', where: ['companyId', '==', profile.companyId] }]; });
    var invitations = (0, react_redux_1.useSelector)(ordered_1.selectInvitations);
    var ownerInvitation = invitations === null || invitations === void 0 ? void 0 : invitations.find(function (inv) { return inv.type === 'accountantAddsOwner'; });
    var invitationsSubmitter = (0, hooks_1.useSingleInvitationsSubmitter)();
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var ownerEmail = (_a = formValues === null || formValues === void 0 ? void 0 : formValues.invitedOwner) === null || _a === void 0 ? void 0 : _a.email;
    var submit = function () {
        if (ownerInvitation)
            return null;
        if (!ownerEmail)
            throw new Error('Missing email');
        return invitationsSubmitter({ email: ownerEmail, accessLevel: interfaces_1.ACCESS_LEVEL.Owner, type: 'accountantAddsOwner' });
    };
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: !ownerInvitation && (!ownerEmail || !!(0, validators_1.getEmailError)(ownerEmail)) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Invite your customer" })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ pt: 2, pb: 4, level: 1 }, { children: ["This person should be the ", (0, jsx_runtime_1.jsx)("strong", { children: "Point of Contact" }), " of ", company.name, ". They\u2019ll be granted the role", (0, jsx_runtime_1.jsx)("strong", { children: " company owner" }), ". This person will have the same permissions as yourself."] })), ownerInvitation
                    ? (0, jsx_runtime_1.jsxs)(Text_1.default, { children: [(0, jsx_runtime_1.jsx)("strong", { children: ownerInvitation.email }), " has been invited!"] })
                    : ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "invitedOwner.email", color: "secondary", component: TextField_1.default, disabled: !(0, react_redux_firebase_1.isLoaded)(invitations), placeholder: "Enter email", title: "Enter email", validate: validators_1.getEmailError, multiline: true }))] })) })));
};
exports.default = AccInviteMembers;
